// Generated by ReScript, PLEASE EDIT WITH CARE


function handleChange(handleChange$1) {
  return event => handleChange$1(event.target.value);
}

function handleSubmit(handleSubmit$1) {
  return event => {
    event.preventDefault();
    return handleSubmit$1();
  };
}

export {
  handleChange,
  handleSubmit,
}
/* No side effect */
